import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import Constants from "../../Action/Constants";
import Logger from "../../Logger/Logger";
import Environment from "../../Environment/Environment";

class LogDisconnect extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(): void {
    if (Environment.isDevelopment() === true) {
      Logger.log("Socket disconnected");
    }

    this.props.dispatch({
      type: Constants.SOCKET_DISCONNECTED
    });
  }

}

export { LogDisconnect };
